import { render, staticRenderFns } from "./CommodityCombinationProperty.vue?vue&type=template&id=29c96135"
import script from "./CommodityCombinationProperty.vue?vue&type=script&lang=js"
export * from "./CommodityCombinationProperty.vue?vue&type=script&lang=js"
import style0 from "./CommodityCombinationProperty.vue?vue&type=style&index=0&id=29c96135&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports